import type { Locale } from 'antd/lib/locale';
import i18n from 'services/i18n';

import antdVi from './vi/antd';
import antdEn from './en/antd';

let antd: Locale = antdEn;

switch (i18n?.language) {
  case 'vi':
    antd = antdVi;
    break;
  default:
    antd = antdEn;
    break;
}

export default antd;
